// The face style in force, read from html[data-faces] (the app sets it from the person's `pref:ui.agentFace` and the look; public/
// econic-boot.js sets it before the first paint). One observer for every face on screen. Absent, it is "icon": other hosts and tests
// draw today's tiles. WP-THEME.
import { useSyncExternalStore } from "react";
import { isFaceStyle, type FaceStyle } from "./types";

const listeners = new Set<() => void>();
let observer: MutationObserver | null = null;

function read(): FaceStyle {
  if (typeof document === "undefined") return "icon";
  const v = document.documentElement.dataset.faces;
  return isFaceStyle(v) ? v : "icon";
}

function subscribe(onChange: () => void): () => void {
  listeners.add(onChange);
  if (!observer && typeof MutationObserver !== "undefined" && typeof document !== "undefined") {
    observer = new MutationObserver(() => listeners.forEach((l) => l()));
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["data-faces"] });
  }
  return () => {
    listeners.delete(onChange);
    if (listeners.size === 0 && observer) {
      observer.disconnect();
      observer = null;
    }
  };
}

/** How the agents are drawn on this screen: "icon" (today's tiles) or "emblem". */
export function useFaceStyle(): FaceStyle {
  return useSyncExternalStore(subscribe, read, () => "icon");
}
